import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const addressFields = [
  { name: "hospital" },
  { name: "ward" },
  { name: "building" },
  { name: "street" },
  { name: "floor" },
  { name: "zipcode" },
  { name: "city", readOnly: true },
  { name: "country", readOnly: true },
];

export const UpdateCenterAddressDialog = ({
  open,
  title,
  address,
  onChange,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title || t("updateCenterAddress")}</DialogTitle>
      <DialogContent sx={{ pt: "8px !important" }}>
        {addressFields.map(({ name, readOnly = false }, index) => (
          <TextField
            key={name}
            autoFocus={index === 0}
            margin="dense"
            label={t(name)}
            value={address[name] || ""}
            fullWidth
            disabled={readOnly}
            onChange={
              readOnly
                ? undefined
                : (event) => onChange(name, event.target.value)
            }
          />
        ))}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="primary" variant="outlined">
          {t("cancel")}
        </Button>
        <Button onClick={onSave} color="primary" variant="contained">
          {t("save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateCenterAddressDialog;
